import moment from 'moment'
import _ from 'lodash'
import {isPresent} from './general'
import {MINUTES_PER_HOUR} from '../date'

export const weekdays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']
export const weekdayObj = weekdays.map((d, i) => ({id: i, name: d}))

export const formats = ['DD-MM-YYYY', 'YYYY-MM-DD']

export const likeDate = val => {
	const mmt = moment(val, formats, true) // without strict any number is valid..
	return !_.isNaN(mmt.hour())
}

export function humanYearDate(date) {
	return moment(date).format('DD MMM YYYY')
}

export function fullHumanYearDate(date) {
	return moment(date).format('DD MMMM YYYY')
}

export function fullHumanDate(date, {dayname = true} = {}) {
	const format = dayname ? "dddd DD MMM 'YY" : "DD MMM 'YY"
	return moment(date).format(format)
}

export function getYearWeekFromDate(date) {
	return {
		week: date.isoWeek(),
		year: date.isoWeekYear(),
	}
}

export function isAfterDate(date, dateTwo = moment()) {
	return getDayDiff(date, dateTwo) >= 0
}

function getDayDiff(date, dateTwo = moment()) {
	date = moment(date)
	dateTwo = moment(dateTwo)
	dateTwo = dateTwo.startOf('day')
	const diff = date.startOf('day').diff(dateTwo, 'd')
	return diff
}

export function inPast(date) {
	return !isAfterDate(date)
}

export const getMonthDays = (month, year) => {
	const start = moment([year, month - 1, 1])
	const startOfMonth = start.format('YYYY-MM-DD')
	const endOfMonth = start.endOf('month').format('YYYY-MM-DD')
	return {startOfMonth, endOfMonth}
}

export function minToHourArray(time) {
	// => [3, 40] for 03:40
	const str = _.isString(time) ? time : minToTimeString(time)
	const split = str.split(':')
	const hours = Number(split[0])
	const mins = Number(split[1])
	return [hours, mins]
}

export const timeStringToDate = val => {
	const date = new Date()
	const vals = val.split(':')
	date.setHours(vals[0], vals[1], 0, 0)
	return date
}

export const roundTime = (time, amt = 1) => {
	time = moment(time)
	const mod = time.minute() % amt
	if (mod === 0) return time
	const remainder = amt - mod
	time.add(remainder, 'minutes')
	return time
}

export function secondsToTimeString(secs) {
	return new Date(secs * 1000).toISOString().substr(11, 8)
}

export const inTimeRange = (dateTime, hours) => {
	const now = moment()
	return now.diff(dateTime, 'hours') <= hours
}

export const formatDate = (date, format = 'DD-MM-YYYY') => {
	return moment(date).format(format)
}

export function convertTimeStr(time) {
	const spT = time.split(':')
	const time1 = spT[0]
	const time2 = spT[1]
	return [Number(time1), Number(time2)]
}

export function timeStringToMin(time = '00:00') {
	if (!_.isString(time)) return 0
	const [hours, mins] = convertTimeStr(time)
	return hours * MINUTES_PER_HOUR + mins
}

export function minutesToString(mins, options = {}) {
	if (!isPresent(mins)) return null
	let prefix = ''
	const sign = Object.prototype.hasOwnProperty.call(options, 'sign') ? options.sign : mins < 0

	if (sign) prefix = mins > 0 ? '+ ' : mins < 0 ? '- ' : ''

	mins = Math.abs(Math.round(mins))

	let mod = mins % MINUTES_PER_HOUR
	let hr
	if (mod > 0) {
		hr = (mins - mod) / MINUTES_PER_HOUR
		if (hr < 10) {
			hr = `0${hr}`
		}
		if (mod < 10) {
			mod = `0${mod}`
		}
		return `${prefix}${hr}:${mod}`
	} else {
		mod = mins / MINUTES_PER_HOUR
		if (mod < 10) {
			mod = `0${mod}`
		}
		return `${prefix}${mod}:00`
	}
}

export function minToTimeString(mins, abs = false) {
	if (!isPresent(mins)) return null

	mins = Math.round(mins)
	let prefix = abs && mins > 0 ? '+ ' : ''
	if (abs) {
		if (mins < 0) prefix = '- '
		mins = Math.abs(mins)
	}
	if (mins < 0) {
		mins = 0
	}
	let mod = mins % MINUTES_PER_HOUR
	let hr
	if (mod > 0) {
		hr = (mins - mod) / MINUTES_PER_HOUR
		if (hr < 10) {
			hr = `0${hr}`
		}
		if (mod < 10) {
			mod = `0${mod}`
		}
		return `${prefix}${hr}:${mod}`
	} else {
		mod = mins / MINUTES_PER_HOUR
		if (mod < 10) {
			mod = `0${mod}`
		}
		return `${prefix}${mod}:00`
	}
}

export function sortDates(dates) {
	return [...dates].sort((a, b) => a.valueOf() - b.valueOf())
}

export function areConsecutiveDates(dates) {
	if (!dates || dates.length < 2) return false

	const sorted = sortDates(dates)
	const normalized = sorted.map(d => (moment.isMoment(d) ? d.clone() : moment(d))).map(d => d.startOf('day'))

	return normalized.slice(1).every((date, i) => date.diff(normalized[i], 'days') === 1)
}
